import { QrCode } from '@mui/icons-material'
import { Chip, ChipProps } from '@mui/material'
import { AxiomaW1 } from '../../types'
import { useClipboard } from '../../hooks/clipboard'

export interface AxiomaW1ChipProps extends Omit<ChipProps, 'label'> {
  w1: AxiomaW1
}

export default function AxiomaW1Chip({ w1, ...props }: AxiomaW1ChipProps) {
  const { copyToClipboard } = useClipboard()

  return (
    <Chip
      icon={<QrCode />}
      label={w1.id}
      size="small"
      {...props}
      onClick={() => copyToClipboard(w1.id)}
    />
  )
}
